import React from "react";
import WeekStrip from "./WeekStrip";
import WeekStripCompact from "./WeekStripCompact";
import AgendaFilters from "./AgendaFilters";
import { cn } from "../../../utils/cn";
import type { AgendaViewport } from "../agendaBreakpoints";
import type {
  AgendaConsultant,
  AgendaFiltersState,
  AgendaWeekSummary,
} from "../agendaTypes";

type AgendaToolbarProps = {
  filters: AgendaFiltersState;
  weekSummary: AgendaWeekSummary;
  cityOptions: string[];
  consultants: AgendaConsultant[];
  showCityFilter: boolean;
  showConsultantFilter: boolean;
  onApplyFilters: (patch: Partial<AgendaFiltersState>) => void;
  viewport?: AgendaViewport;
  className?: string;
};

const AgendaToolbar: React.FC<AgendaToolbarProps> = ({
  filters,
  weekSummary,
  cityOptions,
  consultants,
  showCityFilter,
  showConsultantFilter,
  onApplyFilters,
  viewport = "desktop",
  className,
}) => {
  const isDesktop = viewport === "desktop";
  const isTablet = viewport === "tablet";

  return (
    <div
      className={cn(
        isDesktop
          ? "mb-5 flex flex-col gap-2.5 xl:flex-row xl:items-center xl:justify-between xl:gap-4"
          : isTablet
            ? "mb-4 flex min-w-0 flex-none flex-row items-center justify-start gap-2 overflow-visible"
            : "mb-4 flex flex-col gap-2.5",
        className
      )}
    >
      {isDesktop ? (
        <WeekStrip
          selectedDateIso={filters.date}
          weekSummary={weekSummary}
          onSelectDate={(isoDate) => onApplyFilters({ date: isoDate })}
          className="min-w-0 shrink xl:flex-1"
        />
      ) : (
        <WeekStripCompact
          selectedDateIso={filters.date}
          weekSummary={weekSummary}
          onSelectDate={(isoDate) => onApplyFilters({ date: isoDate })}
          onShiftWeek={(isoDate) => onApplyFilters({ date: isoDate })}
          className={
            isTablet
              ? "w-[214px] shrink-0"
              : undefined
          }
        />
      )}
      <AgendaFilters
        filters={filters}
        cityOptions={cityOptions}
        consultants={consultants}
        showCityFilter={showCityFilter}
        showConsultantFilter={showConsultantFilter}
        onChange={onApplyFilters}
        layout="toolbar"
        className={isTablet ? "flex-none" : undefined}
        cityAsSelect={isTablet}
        dense={isTablet}
      />
    </div>
  );
};

export default AgendaToolbar;
